import React, { useEffect, useState } from 'react'
import { Context } from '../store/Store'
var _ = require('lodash')

const Stepper = ({ steps, setStep, currentStep }) => {
  const { app, dispatch } = React.useContext(Context)

  // Vérifie si une étape a des données remplies
  const hasStepData = (step) => {
    if (!app.poFormState || !step.groupName || !app.poFormState[step.groupName]) return false
    
    const sectionData = app.poFormState[step.groupName]
    
    // Vérifie si au moins un champ a une valeur
    return Object.values(sectionData).some(value => {
      if (value === null || value === undefined || value === '') return false
      if (typeof value === 'object' && Object.keys(value).length === 0) return false
      return true
    })
  }

  return (
    <div className="mt-4 overflow-auto">
      <div className="flex justify-start items-center gap-1">
        {steps.map((step, index) => {
          // Vérifie si cette étape contient des données
          const hasData = hasStepData(step)
          
          // Détermine si le bouton est désactivé
          let isDisabled = false // On permet maintenant de naviguer librement entre les étapes

          if (steps > 2 && index === steps.length - 2) return null
          else
            return (
              <button
                key={`stepper-step-${index}`}
                onClick={() => setStep(index)}
                disabled={isDisabled}
                className={`${
                  currentStep === index ? 'bg-base' : ' bg-base opacity-50'
                } flex flex-col justify-center items-center h-16 md:h-full px-2 md:px-6 xs:py-2 md:py-3 border border-transparent font-medium shadow-sm text-white focus:outline-none relative`}
              >
                {hasData && index !== currentStep && (
                  <div className="absolute top-0 right-0 w-3 h-3 bg-green-500 rounded-full" 
                       title="Cette étape contient déjà des données"></div>
                )}
                <div className="text-xs md:text-lg whitespace-nowrap">
                  Etape {index + 1}
                </div>
                <div className="text-[10px] md:text-xs">
                  {step.stepperLabel}
                </div>
              </button>
            )
        })}
      </div>
    </div>
  )
}

export default Stepper
